import { EmployerAgreementsChangeTemplateSourceService } from '@festina/life-general-types/life/services/EmployerAgreementsChangeTemplateSourceService'
import { useFestinaMutation } from '@festina-life/authentication'

type Props = {
  tenantId: string
  employerAgreementId: string
}

const method =
  EmployerAgreementsChangeTemplateSourceService.changeTemplateSourceServicePostEntity

type MethodParam = NonNullable<Parameters<typeof method>[0]['requestBody']>

export const useSubmitChangeTemplateSourceCommand = ({
  tenantId,
  employerAgreementId,
}: Props) =>
  useFestinaMutation({
    component: 'life',
    roles:
      EmployerAgreementsChangeTemplateSourceService.changeTemplateSourceServicePostEntity_roles,
    isScenario: false,
    mutateFunction: async (arg: MethodParam) => {
      await method({
        xTenantId: tenantId,
        employerAgreementId,
        requestBody: arg,
      })
    },
  })
